import { batch, useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { contentBriefPathes } from '../../../../../constants/queryPathes';
import { defaultBriefOutlineContent, editorTypes } from '../../constants/tiptapEditorConstants';

import { axiosAPI } from '../../../../../utils/axiosAPI';
import { getAxiosHeaders } from '../../../../../utils/helpers/getAxiosHeaders';
import {
    openBasicErrorNotification,
    openBasicWarningNotification,
} from '../../../../../utils/helpers/openBasicErrorNotification';

import {
    updateCurrentOutlineVersionProgress,
    updateCurrentOutlineVersionWordCount,
} from '../../../../pages/contentOptimizer/contentPage/content/briefTab/content/tabsContent/store/contentBriefsOutline.actions';
import {
    updateCurrentEditorContent,
    updateEditorCurrentVersionHeadingCount,
    updateSaveEditorLoading,
} from '../../store/tiptapEditor.actions';
import {
    selectCurrentEditorId,
    selectEditorPreviewVersion,
} from '../../store/tiptapEditor.selectors';

const editorType = editorTypes.OUTLINE;

const useUpdateOutlineEditorContent = () => {
    const dispatch = useDispatch();

    const { contentOptimizerId } = useParams();

    const currentOutlineId = useSelector(selectCurrentEditorId(editorType));
    const editorPreviewVersion = useSelector(selectEditorPreviewVersion(editorType));

    const handleUpdateEditor = (updatedEditorData) => {
        if (contentOptimizerId && currentOutlineId && !editorPreviewVersion) {
            dispatch(updateSaveEditorLoading({ editorType, loading: true }));

            const dataToUpdate = updatedEditorData || defaultBriefOutlineContent;

            axiosAPI
                .patch(
                    `${contentBriefPathes.createContentBrief}/${contentOptimizerId}/outlines/${currentOutlineId}`,
                    { outline: JSON.stringify(dataToUpdate) },
                    { ...getAxiosHeaders() }
                )
                .then(({ data }) => {
                    const { progress, word_count, heading_count } = data || {};

                    if (data) {
                        batch(() => {
                            dispatch(updateCurrentOutlineVersionProgress(progress));
                            dispatch(updateCurrentOutlineVersionWordCount(word_count));
                            dispatch(
                                updateEditorCurrentVersionHeadingCount({
                                    editorType,
                                    headingCount: heading_count,
                                })
                            );
                            dispatch(
                                updateCurrentEditorContent({ editorType, content: dataToUpdate })
                            );
                        });
                    } else {
                        openBasicWarningNotification('No data to update');
                    }
                })
                .catch(() => {
                    openBasicErrorNotification();
                })
                .finally(() => {
                    dispatch(updateSaveEditorLoading({ editorType, loading: false }));
                });
        }
    };

    return handleUpdateEditor;
};

export default useUpdateOutlineEditorContent;
